/*
 * @Description: 数据判断
 */

// ---------------------------------------------------------------------------

/**
 * 判断 data 是否是一个数字或数字字符串
 * @param {Object} data
 */
function isNumeric(data) {
	return (typeof data === 'number' || typeof data === 'string') && isFinite(data) && !isNaN(data - parseFloat(data));
}

/**
 * 判断 obj 是否是对象
 * @param {Object} obj
 */
function isObject(obj) {
	return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}

// ---------------------------------------------------------------------------

export default {
	value: {},
	method: {
		isNumeric,
		isObject
	}
};